import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  button: {
    backgroundColor: 'white !important',
    borderRadius: 5,
    marginBottom: 5,
    marginTop: 5,
    marginRight: 5,
    '&:hover': {
      opacity: 0.8,
    },
  },
  buttonLabel: {
    color: '#4695EC',
    fontSize: 12,
    fontWeight: 600,
  },
  buttonLabelDisabled: {
    color: 'lightgray',
    fontSize: 12,
    fontWeight: 600,
  },
  buttonRaised: {
    backgroundColor: 'white',
  },
});

const LightButton = ({
  classes,
  children,
  onClick,
  disabled,
  ...rest
}) => (
  <Button
    classes={{
      label: disabled ? classes.buttonLabelDisabled : classes.buttonLabel,
      raised: classes.buttonRaised,
      root: classes.button,
    }}
    onClick={onClick}
    disabled={disabled}
    variant="contained"
    {...rest}
  >
    {children}
  </Button>
);

LightButton.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

LightButton.defaultProps = {
  disabled: false,
  onClick: noop,
};

export default withStyles(styles)(LightButton);
